<template>
  <b-modal :id="id" @hidden="clean" @ok="confirm" title="Новые цели" ok-title="Создать цели" header-bg-variant="dark" header-text-variant="light" ok-variant="dark" size="lg">
    <b-form ref="target_form">
      <b-form-group description="Введите цели (по одной на строку): IP, подсеть (CIDR), диапазон IP, домен">
        <b-form-textarea v-model="rawInput" placeholder="10.0.2.4&#10;192.168.1.0/24&#10;10.0.0.1-10.0.0.50&#10;scanme.nmap.org" :state="targetState" rows="6" max-rows="12"/>
      </b-form-group>
      <div v-if="parsedTargets.length > 0" class="mt-2">
        <b-form-text class="text-muted mb-1">Будет добавлено {{ parsedTargets.length }} {{ pluralize(parsedTargets.length) }}:</b-form-text>
        <b-list-group flush style="max-height: 200px; overflow-y: auto;">
          <b-list-group-item v-for="(t, i) in parsedTargets" :key="i" class="d-flex justify-content-between align-items-center py-1">
            <span><b-badge :variant="typeVariant(t.type)" class="mr-2">{{ t.type }}</b-badge>{{ t.target }}</span>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-form>
    <b-progress v-if="processed > 0 && parsedTargets.length > 1" :value="processed" :max="parsedTargets.length" variant="danger" show-value class="mt-2"/>
  </b-modal>
</template>

<script>
import RekonoApi from '@/backend/RekonoApi'
export default {
  name: 'targetModal',
  mixins: [RekonoApi],
  props: {
    id: String,
    projectId: [Number, String]
  },
  data () {
    return {
      rawInput: '',
      parsedTargets: [],
      targetState: null,
      processed: 0
    }
  },
  watch: {
    rawInput (val) {
      this.parseTargets(val)
    }
  },
  methods: {
    parseTargets (input) {
      const lines = input.split(/[\n,;]+/).map(s => s.trim()).filter(s => s.length > 0)
      this.parsedTargets = lines.map(line => {
        return { target: line, type: this.detectType(line) }
      })
      this.targetState = this.parsedTargets.length > 0 ? true : null
    },
    detectType (value) {
      // CIDR: 192.168.1.0/24
      if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\/\d{1,2}$/.test(value)) return 'Network'
      // IP range: 10.0.0.1-10.0.0.50 or 10.0.0.1-50
      if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}-\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(value)) return 'IP range'
      if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}-\d{1,3}$/.test(value)) return 'IP range'
      // Private IP: 10.x, 192.168.x, 172.16-31.x
      if (/^(10\.|192\.168\.|172\.(1[6-9]|2[0-9]|3[01])\.)/.test(value) && /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(value)) return 'Private IP'
      // Public IP
      if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(value)) return 'Public IP'
      // Domain
      return 'Domain'
    },
    typeVariant (type) {
      const map = {
        'Network': 'danger',
        'IP range': 'warning',
        'Private IP': 'info',
        'Public IP': 'primary',
        'Domain': 'success'
      }
      return map[type] || 'secondary'
    },
    pluralize (n) {
      const forms = ['цель', 'цели', 'целей']
      const mod10 = n % 10
      const mod100 = n % 100
      if (mod10 === 1 && mod100 !== 11) return forms[0]
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return forms[1]
      return forms[2]
    },
    check () {
      this.parseTargets(this.rawInput)
      this.targetState = this.parsedTargets.length > 0
      return this.targetState
    },
    confirm (event) {
      event.preventDefault()
      if (this.check()) {
        for (let index in this.parsedTargets) {
          const t = this.parsedTargets[index]
          this.post('/api/targets/', { project: this.projectId, target: t.target }, t.target, 'Новая цель создана успешно')
            .catch(() => { return Promise.resolve(false) })
            .then(() => {
              this.processed += 1
              if (this.processed === this.parsedTargets.length) {
                this.$emit('confirm', { id: this.id, success: true, reload: true })
              }
            })
        }
      }
    },
    clean () {
      this.rawInput = ''
      this.parsedTargets = []
      this.targetState = null
      this.processed = 0
    }
  }
}
</script>